import React from 'react'
import { VerificationAccountHomePage } from '@mobi/account/Areas/VerificationAccount'
import { useBetAccount } from '@mobi/account/Hooks'
import { useDisableAppHeaderRender } from '../../Areas/AppHeader/hooks/useDisableAppHeaderRender'
import { useLogon } from '../../Utils/hooks'
import { useMatch } from 'react-router'
import { routes as signupRoutes } from '@mobi/account/Areas/SignUp/Utils/routes'

export const VerificationAccountGate = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn, accountNumber } = useLogon()
  const enabled = isLoggedIn === true && accountNumber !== null
  const { data: betAccount, isError: isBetAccountError } = useBetAccount({ enabled })
  const isVerificationAccount = betAccount?.IdVerificationOnlyInd?.toUpperCase() === 'Y'
  const isSignupPage = useMatch(signupRoutes.any)

  if (!isSignupPage && isLoggedIn && (isVerificationAccount || isBetAccountError)) {
    return (
      <VerificationAccountHomePage
        betAccountNumber={betAccount?.BetAccountNumber}
        useDisableAppHeaderRender={useDisableAppHeaderRender}
        isBetAccountError={isBetAccountError}
      />
    )
  }

  return <>{children}</>
}
